module.exports = __webpack_public_path__ + "static/img/placeholder.c5333da.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/placeholder.jpg
// module id = 2jJp
// module chunks = 12